<template>
  <div class="manage-description-field form-control h-auto" v-if="editor">
    <editor-content class="editor__content" :editor="editor" @click="() => editor.focus()"/>
    <hr class="my-2"/>
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive, getMarkAttrs }">
      <div class="menubar" v-if="Array.isArray(extensions) && extensions.length">
        <template v-for="key in extensions">
          <b-btn v-if="key === 'strong'" :key="key"
            @click.prevent="commands.bold" :pressed="isActive.bold()" size="sm" variant="outline-primary">
              <font-awesome-icon icon="bold"/>
          </b-btn>
          <b-btn v-if="key === 'italic'" :key="key"
            @click.prevent="commands.italic" :pressed="isActive.italic()" size="sm" variant="outline-primary">
              <font-awesome-icon icon="italic"/>
          </b-btn>
          <b-btn v-if="key === 'strike'" :key="key"
            @click.prevent="commands.strike" :pressed="isActive.strike()" size="sm" variant="outline-primary">
              <font-awesome-icon icon="strikethrough"/>
          </b-btn>
          <b-btn v-if="key === 'link'" :key="key"
            @click.prevent="promptForLink(commands.link, getMarkAttrs('link'))" :pressed="isActive.link()"
            size="sm" variant="outline-primary">
              <font-awesome-icon icon="link"/>
          </b-btn>
        </template>
      </div>
    </editor-menu-bar>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import { Bold, Italic, Strike, Link, Placeholder, ListItem, OrderedList } from 'tiptap-extensions';

export default {
  props: {
    extensions: Array,
    placeholder: String,
    value: String,
  },
  components: {
    EditorContent,
    EditorMenuBar,
  },
  data: () => ({
    editor: null,
  }),
  created() {
    const extensions = Array.isArray(this.extensions) ? this.extensions.reduce(selectExtensions, []) : [];

    if (this.placeholder) {
      extensions.push(new Placeholder({
        emptyEditorClass: 'is-editor-empty',
        emptyNodeClass: 'is-empty',
        emptyNodeText: this.placeholder,
        showOnlyWhenEditable: true,
        showOnlyCurrent: true,
      }));
    }

    this.editor = new Editor({
      extensions,
      content: this.value,
      onUpdate: ({ getHTML }) => this.$emit('input', handleEmptyValues(getHTML())),
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    async promptForLink(command, { href }) {
      if (href) {
        command({ href: null });
      } else {
        try {
          const { $createElement: el } = this;
          const input = el('b-form-input', {
            props: { placeholder: 'https://...', value: href },
            on: { input: value => href = value },
          });

          await this.$bvModal.msgBoxOk([ input ], {
            hideHeader: true,
            footerClass: 'border-0 pt-0',
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            okTitle: 'Save',
          });

          command({ href });
        } catch (err) {
          this.$notifyErr(err);
        }
      }
    },
  },
};

function selectExtensions(extensions, key) {
  switch (`${key}`.toLowerCase()) {
    case 'bold': case 'strong': case 'b': return extensions.concat(new Bold());
    case 'italic': case 'em': case 'i': return extensions.concat(new Italic());
    case 'strike': return extensions.concat(new Strike());
    case 'link': case 'a': return extensions.concat(new Link());
    case 'ul': return extensions.concat(new ListItem());
    case 'ol': return extensions.concat(new OrderedList());
    default: return extensions;
  }
}

function handleEmptyValues(input) {
  return input === '<p></p>' ? null : input;
}
</script>

<style lang="scss">
.manage-description-field {
  .editor__content {
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
  }

  .ProseMirror {
    outline: none;
    &:focus { outline: none; }

    p {
      font-size: inherit;
    }

    p.is-editor-empty:first-child::before {
      content: attr(data-empty-text);
      float: left;
      color: #aaa;
      pointer-events: none;
      height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manage/DescriptionField.vue